'use client';

interface Step8Props {
  domain: string;
  selectedEmails: string[];
  paymentChoice: 'pay' | 'callback';
  onRestart: () => void;
}

export default function Step8Confirmation({
  domain,
  selectedEmails,
  paymentChoice,
  onRestart,
}: Step8Props) {
  const isPaid = paymentChoice === 'pay';

  return (
    <div className="animate-fade-in max-w-lg mx-auto text-center">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <span className="text-success text-4xl">&#10003;</span>
      </div>

      <h2 className="text-2xl font-bold mb-2">
        {isPaid ? 'Commande confirmée !' : 'Demande enregistrée !'}
      </h2>
      <p className="text-muted mb-8">
        {isPaid
          ? 'Votre paiement a été reçu. Nous procédons à la configuration de vos emails.'
          : 'Un conseiller vous contactera dans les plus brefs délais pour finaliser votre commande.'}
      </p>

      <div className="bg-white border border-border rounded-xl p-5 text-left mb-6">
        <p className="text-xs text-muted uppercase tracking-wide mb-3">Votre commande</p>

        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted">Domaine</span>
            <span className="font-mono font-semibold text-primary">{domain}</span>
          </div>

          <div className="border-t border-border pt-3">
            <span className="text-sm text-muted">Adresses email</span>
            <div className="mt-2 space-y-1">
              {selectedEmails.map((prefix) => (
                <p key={prefix} className="font-mono text-sm">
                  {prefix}@{domain}
                </p>
              ))}
            </div>
          </div>

          <div className="border-t border-border pt-3">
            <span className="text-sm text-muted">Statut</span>
            <p className="font-medium mt-1">
              {isPaid ? (
                <span className="text-success">Payé - En cours de configuration</span>
              ) : (
                <span className="text-primary">En attente de rappel</span>
              )}
            </p>
          </div>
        </div>
      </div>

      {isPaid && (
        <div className="bg-primary-light/50 rounded-xl p-5 text-left mb-6">
          <p className="font-semibold text-sm mb-3">Prochaines étapes</p>
          <ol className="space-y-2 text-sm text-muted list-decimal list-inside">
            <li>Achat et configuration de votre domaine</li>
            <li>Configuration DNS</li>
            <li>Création de vos adresses email</li>
            <li>Envoi de vos identifiants par email</li>
            <li>Assistance pour l&apos;installation sur vos appareils</li>
          </ol>
        </div>
      )}

      <button
        onClick={onRestart}
        className="text-primary hover:text-primary-hover font-medium text-sm transition-colors cursor-pointer"
      >
        Faire une nouvelle simulation
      </button>
    </div>
  );
}